import * as Vuex from "vuex";
import { FilenameFormat } from "@/entities/filename-format";
import { httpByCurrentCustomer } from "@/lib/client";

export type createFilenameFormat = {
  name: string;
  format: string;
};
const FilenameFormatModule: Vuex.Module<filenameFormatStoreState, {}> = {
  state: {
    listFilenameFormat: [], //Donde se guardara la consulta de los buckets
  },
  getters: {
    filenameFormatTable(state) {
      return state.listFilenameFormat;
    },
  },
  mutations: {
    SET_FILENAME_FORMAT_TABLE(state, payload: FilenameFormat[]) {
      state.listFilenameFormat = payload;
    },
    REMOVE_FILENAME_FORMAT_ITEM(state, id: string) {
      state.listFilenameFormat = state.listFilenameFormat.filter(
        (t) => t.id != id
      );
    },
  },
  actions: {
    async getFilenameFormat({ commit }) {
      const responseFilenameFormat = await httpByCurrentCustomer()
        .get("filenameFormats")
        .json<FilenameFormat[]>();
      if (Array.isArray(responseFilenameFormat)) {
        commit("SET_FILENAME_FORMAT_TABLE", responseFilenameFormat);
      }
    },
    async deleteFilenameFormat({ commit }, filenameFormatDeleteRequest: any) {
      await httpByCurrentCustomer()
        .delete("", { json: filenameFormatDeleteRequest }) //TODO Colocar el endopoint
        .json<null>()
        .then(() => {
          commit("", filenameFormatDeleteRequest.storageId);
        });
    },
    async createFilenameFormat({ commit }, payload: createFilenameFormat) {
      await httpByCurrentCustomer()
        .post("filenameFormats", { json: payload })
        .json<createFilenameFormat>();
    },
  },
  namespaced: true,
};

type filenameFormatStoreState = {
  //loading: boolean;
  listFilenameFormat: FilenameFormat[];
};
export default FilenameFormatModule;
